import React from "react";
import { Table } from "src/components/event_transaction/components/shared/Table";
import { Text } from "src/components/ui/Text";

const TableListUnits = ({ dataUnitsById }) => {
  console.log({ dataUnitsById });

  return (
    <div className="w-full">
      <Table
        data={dataUnitsById?.data}
        columns={[
          {
            key: "assetCode",
            label: "Asset code",
            columnsWidth: "100px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => (
              <Text className="text-vekin-green100 font-semibold text-sm text-ellipsis overflow-hidden">
                {value ?? "-"}
              </Text>
            ),
          },
          {
            key: "landPlotSizeColumn",
            label: "Land Plot Size",
            columnsWidth: "80px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => {
              const landPlotSize = value?.land_plot_size;
              const landPlotSizeUnit = value?.land_plot_size_unit;

              return (
                <Text className="font-normal text-sm text-primary text-ellipsis overflow-hidden">
                  {landPlotSize && landPlotSizeUnit
                    ? `${landPlotSize} ${landPlotSizeUnit}`
                    : "-"}
                </Text>
              );
            },
          },
          {
            key: "usableAreaColumn",
            label: "Usable Area",
            columnsWidth: "80px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => {
              const usableArea = value?.usable_area;
              const usableAreaUnit = value?.usable_area_unit;

              return (
                <Text className="font-normal text-sm text-primary text-ellipsis overflow-hidden">
                  {usableArea && usableAreaUnit
                    ? `${usableArea} ${usableAreaUnit}`
                    : "-"}
                </Text>
              );
            },
          },
          {
            key: "gfaColumn",
            label: "GFA",
            columnsWidth: "80px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => {
              const gfa = value?.gfa;
              const gfaUnit = value?.gfa_unit;

              return (
                <Text className="font-normal text-sm text-primary text-ellipsis overflow-hidden">
                  {gfa && gfaUnit ? `${gfa} ${gfaUnit}` : "-"}
                </Text>
              );
            },
          },
          {
            key: "nlaColumn",
            label: "NLA",
            columnsWidth: "80px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => {
              const nla = value?.nla;
              const nlaUnit = value?.nla_unit;

              return (
                <Text className="font-normal text-sm text-primary text-ellipsis overflow-hidden">
                  {nla && nlaUnit ? `${nla} ${nlaUnit}` : "-"}
                </Text>
              );
            },
          },
          {
            key: "divestmentDate",
            label: "Divestment Date",
            columnsWidth: "100px",
            renderHead: ({ label }) => (
              <label className="flex items-center gap-2 font-medium">
                <span className="text-sm leading-4 text-vekin">{label}</span>
              </label>
            ),
            renderBody: ({ value }) => (
              <Text className="font-normal text-sm text-primary text-ellipsis overflow-hidden">
                {value ?? "N/A"}
              </Text>
            ),
          },
        ]}
      />
      {/* <TablePagination
        rows={rows}
        setRows={setRows}
        page={page}
        setPage={setPage}
        dataTable={dataEventFactors}
      /> */}
    </div>
  );
};

export default TableListUnits;
